import { useCallback } from 'react';

import qs from 'qs';

import { usePetitionGuidesPageData } from '#src/app/pages/petitionGuides/article/pageContext';
import { useCurrentUser, useSessionUuid } from '#src/app/shared/hooks/session';
import type { ShareActionsOptions } from '#src/app/shared/hooks/share';

import type { Channel } from './types';

export function useGetShareUrl(): ShareActionsOptions<Channel>['getUrl'] {
	const {
		data: {
			article: { slug },
		},
	} = usePetitionGuidesPageData();
	const user = useCurrentUser();
	const sessionUuid = useSessionUuid();

	return useCallback(
		(medium) => {
			const trackParams = qs.stringify(
				{
					recruiter: user?.id || undefined,
					recruited_by_id: sessionUuid,
					utm_source: 'share_petition_guides_article',
					utm_campaign: `share_${medium}_responsive`,
					utm_medium: medium,
				},
				{ encodeValuesOnly: true },
			);
			return `/petition-guides/${encodeURIComponent(slug)}?${trackParams}`;
		},
		[slug, sessionUuid, user],
	);
}
